import * as api from '@tytapp/api';
import { Model } from '@tytapp/common';
import { Production } from '.';

@Model('Talent')
export class Talent extends api.ApiTalent {
}
